import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin } from "lucide-react";

const FOUNDER_LINKEDIN =
    "https://www.linkedin.com/in/chiraag-shridhar-30908152";

export default function Footer() {
    return (
        <footer
            data-testid="global-footer"
            className="bg-slate-900 text-slate-300 pt-20 pb-10 px-4 sm:px-6 lg:px-8"
        >
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14 border-b border-slate-800">
                    <div className="md:col-span-4">
                        <Link to="/" className="inline-flex items-center mb-5">
                            <img
                                src="/assets/beeta-logo-transparent.webp"
                                alt="Beeta Logistics"
                                className="h-12 w-auto"
                            />
                        </Link>
                        <p className="text-sm text-slate-400 leading-relaxed max-w-sm">
                            Transportation beyond compare. We run 3PL, warehousing,
                            transport and cold-chain for India&apos;s most demanding
                            shippers — with the SLAs and technology to back it.
                        </p>
                        <div className="flex gap-2 mt-6">
                            <a
                                href={FOUNDER_LINKEDIN}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Beeta Logistics on LinkedIn"
                                data-testid="footer-social-linkedin"
                                className="w-9 h-9 rounded-full bg-slate-800 hover:bg-blue-600 flex items-center justify-center transition-colors"
                            >
                                <Linkedin className="w-4 h-4 text-white" />
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-2">
                        <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-5">
                            Company
                        </div>
                        <ul className="space-y-3 text-sm">
                            <li><Link to="/about" data-testid="footer-link-about" className="hover:text-white">About</Link></li>
                            <li><Link to="/services" data-testid="footer-link-services" className="hover:text-white">Services</Link></li>
                            <li><Link to="/track" data-testid="footer-link-track" className="hover:text-white">Track Shipment</Link></li>
                            <li><Link to="/blog" data-testid="footer-link-news" className="hover:text-white">News</Link></li>
                            <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-white">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-5">
                            Services
                        </div>
                        <ul className="space-y-3 text-sm">
                            <li><Link to="/services/3pl-logistics" data-testid="footer-service-3pl" className="hover:text-white">3PL Logistics</Link></li>
                            <li><Link to="/services/warehousing" data-testid="footer-service-warehousing" className="hover:text-white">Warehousing</Link></li>
                            <li><Link to="/services/transporting" data-testid="footer-service-transporting" className="hover:text-white">Transporting</Link></li>
                            <li><Link to="/services/auto-industry" data-testid="footer-service-auto" className="hover:text-white">Auto 3PL</Link></li>
                            <li><Link to="/services/cold-chain" data-testid="footer-service-cold-chain" className="hover:text-white">Cold Chain</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-5">
                            Reach Us
                        </div>
                        <ul className="space-y-4 text-sm">
                            <li className="flex items-start gap-3">
                                <MapPin className="w-4 h-4 mt-0.5 text-blue-400 shrink-0" />
                                <span>1816, Tower-4, DLF Corporate Greens, Sector 74-A, Gurgaon 122004, Haryana, India</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Phone className="w-4 h-4 text-blue-400 shrink-0" />
                                <a href="tel:+919958018358" data-testid="footer-phone" className="hover:text-white">+91 99580 18358</a>
                            </li>
                            <li className="flex items-center gap-3">
                                <Mail className="w-4 h-4 text-blue-400 shrink-0" />
                                <a href="mailto:info@beetalogistics.com" data-testid="footer-email" className="hover:text-white">info@beetalogistics.com</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-slate-500">
                    <div className="text-center sm:text-left">
                        © {new Date().getFullYear()} Beeta Logistics Private Limited · Incorporated 2015 · GSTIN 06AAGCB5268A1ZZ
                    </div>
                    <div className="text-center sm:text-right">
                        <Link
                            to="/privacy-policy"
                            data-testid="footer-link-privacy"
                            className="hover:text-white transition-colors"
                        >
                            Privacy Policy
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
